import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  StripeConnectHeader,
  StatusGrid,
  RequirementsList,
  ConnectActionButtons,
} from './StripeConnectParts';
import { useStripeConnect } from './useStripeConnect';

/**
 * StripeConnectCard — embeds Stripe Connect Standard onboarding into /billing.
 *
 * Thin orchestrator. State lives in `useStripeConnect`; presentation lives in
 * `StripeConnectParts`. This file just wires them together.
 */
export default function StripeConnectCard() {
  const { status, error, busy, loadStatus, startOrResumeOnboarding, openDashboard } = useStripeConnect();

  if (status === null) {
    return (
      <div className="rounded-2xl border border-[#1f1f1f] bg-[#0A0A0A] p-6 flex items-center gap-3 text-sm text-gray-500" data-testid="stripe-connect-card-loading">
        <Loader2 className="h-4 w-4 animate-spin text-[#00D4FF]" /> Loading Stripe Connect status…
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl border border-[#1f1f1f] bg-gradient-to-br from-[#0A0A0A] to-[#101820] p-6"
      data-testid="stripe-connect-card"
    >
      <StripeConnectHeader onboarded={status.onboarding_complete} />
      <StatusGrid status={status} />
      <RequirementsList items={status.requirements_due} />
      {error && (
        <div
          className="mt-3 text-[11px] text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg p-3"
          data-testid="stripe-connect-error"
        >
          {error}
        </div>
      )}
      <ConnectActionButtons
        status={status}
        busy={busy}
        onStart={startOrResumeOnboarding}
        onDashboard={openDashboard}
        onRefresh={loadStatus}
      />
    </div>
  );
}
